module.exports = __webpack_public_path__ + "pc/img/brand02.b7f3fef1.png";